module.exports = __webpack_public_path__ + "img/49.f43d7f0b.jpg";